import { CSS_GENERIC_FONT_FAMILIES } from '../constants/fonts';
import { CanvasJSON } from '../../canvas/types';
import { isTextFabricType } from './is-text-type';

const genericFamilies = new Set(CSS_GENERIC_FONT_FAMILIES);

const parsePrimaryFont = (fontFamily: string): string | null => {
  const first = fontFamily.split(',')[0].trim();
  const unquoted = first.replace(/^['"]|['"]$/g, '');
  return unquoted && !genericFamilies.has(unquoted.toLowerCase()) ? unquoted : null;
};

const addFontSpec = (
  fonts: Set<string>,
  family: string,
  weight: string | number = 'normal',
  size: number = 0,
  style: string = 'normal'
) => {
  const primary = parsePrimaryFont(family);
  if (!primary) return;
  fonts.add(`${style} ${weight} ${size}px "${primary}"`);
};

const collectFontSpecsFromJSON = (json: CanvasJSON): Set<string> => {
  const fonts = new Set<string>();

  for (const obj of json.objects) {
    if (!isTextFabricType(obj.type as string | undefined)) continue;

    addFontSpec(
      fonts,
      obj.fontFamily as string,
      obj.fontWeight as string | number,
      obj.fontSize as number,
      obj.fontStyle as string
    );
  }

  return fonts;
};

export const preloadFonts = async (json: CanvasJSON): Promise<void> => {
  const fonts = collectFontSpecsFromJSON(json);
  if (fonts.size > 0) {
    await Promise.all(Array.from(fonts).map(f => document.fonts.load(f)));
  }

  await document.fonts.ready;
};
